import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import JsonCSV from 'vue-json-csv'
import '@babel/polyfill'
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

Vue.component('downloadCsv', JsonCSV)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
